import { render, staticRenderFns } from "./PdfDocument.vue?vue&type=template&id=5df928f1&"
import script from "./PdfDocument.vue?vue&type=script&lang=js&"
export * from "./PdfDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports